import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail,
    CLEAR as clear
} from '../../actions/segments/detail';

const initialState = {
    data: null,
    loading: false,
    error: null
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case req:
            return {
                ...state,
                loading: true,
                error: null
            };
        case res:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case fail:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case clear:
            return {
                ...initialState
            };
        default:
            return state;
    }
}; 